// Banner colours and icon for each notice level (the display level the model
// function sets on the notice). Placeholders until product picks the final
// ones; warning is copied from the Retest Recommended banner (ViewSample.js).
const LEVEL_STYLES = {
  error: {
    label: "Error",
    backgroundColor: "#f8d7da",
    borderColor: "#dc3545",
    textColor: "#AE0000",
    iconClass: "bi-exclamation-octagon-fill",
  },
  warning: {
    label: "Warning",
    backgroundColor: "#fff3cd",
    borderColor: "#ffc107",
    textColor: "#e65c00",
    iconClass: "bi-exclamation-triangle-fill",
  },
  advisory: {
    label: "Information",
    backgroundColor: "#e7f1ff",
    borderColor: "#0d6efd",
    textColor: "#084298",
    iconClass: "bi-info-circle-fill",
  },
};

/**
 * A customer notice (e.g. fluorescence) on the results page. `notice` comes
 * from getBannerNotices; only its message is shown, never its
 * fluorescenceScore. An unknown or missing level is shown as a warning.
 */
export default function CustomerNoticeBanner({ notice }) {
  const style = LEVEL_STYLES[notice.level] ?? LEVEL_STYLES.warning;

  return (
    <div
      className='d-flex align-items-center gap-2 px-3 py-2 rounded mb-2'
      style={{
        backgroundColor: style.backgroundColor,
        border: `2px solid ${style.borderColor}`,
        fontWeight: "bold",
      }}
    >
      <i
        className={`bi ${style.iconClass}`}
        role='img'
        aria-label={style.label}
        style={{ fontSize: "1.2rem", color: style.textColor, flexShrink: 0 }}
      ></i>
      <span style={{ color: style.textColor }}>{notice.message}</span>
    </div>
  );
}
